export const DIALOG_TEXTS = {
  HEADER: 'Confirm PgPubLogout',
  CONTENT: 'Are you sure you want to log out?',
  DESCRIPTION: 'You will need to sign in again to access your account.',
  CANCEL_BUTTON: 'Cancel',
  LOGOUT_BUTTON: 'PgPubLogout'
}; 